import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import { isStatusDragged } from "../../abstract/redux/slice/statusSlice";
import ElementComment from "./ElementComment";
import ElementLabel from "./ElementLabel";
import ElementValue from "./ElementValue";
import styles from "./Meta.module.scss";

function Meta({ node, status, show }) {

  if (!show) {
    return null;
  }

  const _name = nodeUtils.getName(node);

  if (!_name) {
    return null;
  }

  if (isStatusDragged(status)) {
    return null;
  }

  const _isChoice = nodeUtils.isChoice(node);
  const _isFunction = nodeUtils.isFunction(node);
  const _isAbstract = _isChoice ? nodeUtils.isAbstract(node) : false;

  return (
    <div className={`${styles["meta__options"]}`}>
      {_isChoice && !_isAbstract && <ElementValue node={node} />}
      {!_isFunction && <ElementLabel node={node} />}
      <ElementComment node={node} />
    </div>
  );
}

export default Meta;
